import React from 'react';
import propTypes from './propTypes';

const OvergrowthRisk = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8516_29840)">
      <path d="M15.5 9L7 23.7224H12.5554V21.7594H10.4L15.5 12.926L20.6 21.7594H18.4444V23.7224H24L15.5 9Z" fill="currentColor" />
      <path d="M13.5 19.5L15.4999 16L17.5 19.5H16.4814V20.7779H14.5184V19.5H13.5Z" fill="currentColor" />
      <path d="M14.5184 21.7594H16.4814V23.7224H14.5184V21.7594Z" fill="currentColor" />
      <path d="M5 3.27C3.17 4.73 2 6.98 2 9.5C2 13.5382 5.01234 16.8873 8.90776 17.418L7.84083 19.266C3.35838 18.2804 0 14.2856 0 9.5C0 6.51 1.32 3.83 3.4 2H1V0H7V5H5V3.27Z" fill="currentColor" />
      <path d="M19.4345 12.8148C19.8005 11.7779 20 10.6624 20 9.5H18C18 9.75882 17.9877 10.0147 17.9635 10.2671L19.4345 12.8148Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M17.1681 8.88943C18.5247 6.75557 18.9047 3.91325 18.9992 1.539C19.0105 1.2563 18.9014 0.982059 18.6992 0.784248C18.4969 0.586438 18.2203 0.48357 17.9379 0.501139C15.7614 0.636555 13.0852 1.23655 11.2928 3.46105L11.2884 3.46653C10.2274 4.80238 9.64675 6.51899 9.33223 8.25147C8.11437 6.9254 6.39477 6.58073 5.05962 6.50099C4.77735 6.48413 4.50113 6.58757 4.29936 6.7857C4.09759 6.98382 3.98914 7.25811 4.00086 7.54065C4.06664 9.1266 4.35103 11.1652 5.52416 12.5831L5.52867 12.5886C6.48942 13.7332 7.80691 14.2062 9 14.3967V16.4992H9.43821L11 13.7941V12.4101C11.2897 12.3737 11.5842 12.3272 11.8809 12.2684L13.3692 9.69059C12.6609 10.0408 11.8784 10.2561 11.0705 10.3811C11.2561 8.20146 11.7476 6.10593 12.8523 4.71318C13.8721 3.44939 15.3526 2.86136 16.9295 2.61728C16.7999 4.13854 16.5214 5.61881 15.9894 6.84778L17.1681 8.88943ZM8.89925 12.3405C8.7562 11.278 8.46483 10.3325 7.93714 9.69296C7.47956 9.14928 6.83747 8.83099 6.10075 8.6579C6.24381 9.7204 6.53518 10.666 7.06287 11.3055C7.52045 11.8491 8.16254 12.1674 8.89925 12.3405Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_8516_29840">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

OvergrowthRisk.propTypes = propTypes;

export default OvergrowthRisk;
